import { GlobalService } from 'src/app/_services/global.service';
import { Component, AfterViewInit, OnDestroy, Renderer2, OnInit, Inject, HostListener, DoCheck } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { formatDate } from '@angular/common';
import { AppComponent } from './app.component';
import { ConfigService } from './service/app.config.service';
import { AppConfig } from './api/appconfig';
import { LayoutService } from './components/layout/services/app.layout.service';
import { filter, Subscription } from 'rxjs';
import { WhiteLabelList } from './_data/white-label-list';
import { UserService } from './_services/user.service';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { AppBaseDataService } from './_services/app-base-data.service';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { SubscriptionPlanService } from './_services/subscription-plan.service';
import { BusinessSetupService } from './_services/business-setup.service';
import { BusinessSetupProgressService } from './_services/business-setup-progress.service';
import { StripeCardSavedEvent } from './_services/stripe-card.service';

import { BusinessSetupModel, SubscriptionModel } from 'src/app/_models/subscription-management/subscription-model';
import { PlanInfo } from 'src/app/_models/subscription-management/user-subscription-info';
import { Plan } from 'src/app/_models/subscription-plan/plan';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styles: [`
        .status-strip{
            background: #6f1f0e;
            color: #ffffff;
            text-align: center;
            height: var(--dashboard-v2-banner-height);
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: 600;
            width: 100%;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 1205;
            line-height: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .status-strip-text{
            display: block;
            max-width: calc(100% - 140px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .status-strip-success{
            background: #15803d;
        }
        .status-strip-action{
            border: 0;
            background: transparent;
            color: #ffffff;
            font-size: 12px;
            font-weight: 700;
            text-decoration: underline;
            cursor: pointer;
            padding: 0;
            margin-left: 8px;
            flex: 0 0 auto;
        }
        .layout-wrapper.online-store-setup-route .layout-topbar,
        .layout-wrapper.online-store-setup-route .layout-sidebar{
            top: 0 !important;
        }
        .layout-wrapper.online-store-setup-route .layout-sidebar{
            height: 100vh !important;
        }
        .layout-wrapper.online-store-setup-route .layout-main-container,
        .layout-wrapper.online-store-setup-route .layout-main-container.no-banner{
            padding-top: 4rem !important;
        }
        .plan-expired-banner{
            border: 1px solid #f5c2c7;
            background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);
            color: #b02a37;
            border-radius: 8px;
            margin-top: 12px;
        }
        .plan-expired-banner .banner-icon{
            font-size: 24px;
            color: #b02a37;
        }
        .plan-expired-banner .alert-title{
            font-weight: 700;
        }
        .plan-expired-banner .alert-subtitle{
            color: #7a1c23;
            font-weight: 600;
        }
        .layout-main-container{
            padding-top: 5rem; /* match topbar height */
        }
        .layout-main-container.has-plan-banner{
            padding-top: 6.5rem; /* topbar + banner breathing room */
        }
        .layout-main-container.no-banner{
            padding-top: 4rem;
            padding-right: 1rem;
            padding-bottom: 2rem;
            padding-left: 1rem;
        }
        .layout-main-container.no-banner .layout-main{
            margin-top: 2rem;
        }
        .trial-lockout-overlay{
            position: fixed;
            inset: 0;
            z-index: 2000;
            background: rgba(5, 7, 13, .92);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 24px;
        }
        .trial-lockout-card{
            max-width: 420px;
            width: 100%;
            background: #ffffff;
            border-radius: 16px;
            padding: 32px;
            text-align: center;
            box-shadow: 0 20px 60px rgba(0, 0, 0, .35);
        }
        .trial-lockout-icon{
            font-size: 32px;
            color: #b02a37;
            margin-bottom: 12px;
            display: inline-block;
        }
        .trial-lockout-card h2{
            margin: 0 0 12px;
            font-size: 20px;
            font-weight: 700;
        }
        .trial-lockout-card p{
            margin: 0 0 22px;
            color: #475467;
            font-size: 14px;
            line-height: 1.6;
        }
        .trial-lockout-error{
            margin: 14px 0 0;
            color: #b02a37;
            font-size: 13px;
            font-weight: 600;
        }
        @media (max-width: 768px) {
            .status-strip{
                height: auto;
                min-height: var(--dashboard-v2-banner-height);
                padding: 8px 12px;
                line-height: 1.25;
                white-space: normal;
                gap: 6px;
                flex-wrap: wrap;
            }
            .status-strip-text{
                max-width: 100%;
                white-space: normal;
            }
        }
    `],
    animations: [
        trigger('submenu', [
            state('hidden', style({
                height: '0px'
            })),
            state('visible', style({
                height: '*'
            })),
            transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})

export class AppMainComponent implements AfterViewInit, OnDestroy, OnInit, DoCheck {

    public menuInactiveDesktop: boolean;

    public menuActiveMobile: boolean;

    public overlayMenuActive: boolean;

    public staticMenuInactive: boolean = false;

    public profileActive: boolean;

    public topMenuActive: boolean;

    public topMenuLeaving: boolean;

    public theme: string;

    documentClickListener: () => void;

    menuClick: boolean;

    topMenuButtonClick: boolean;

    configActive: boolean;

    configClick: boolean;

    config: AppConfig;

    subscription: Subscription;
    storeContentBannerConfigSubscription?: Subscription;
    storeContentStateRefreshSubscription?: Subscription;
    //IsOnSubscriptionPage=false
    items: MenuItem[];

    _globals = GlobalService
    isOnlineStore: boolean = false;
    dayLeftInRenewal: number = 0;
    IsUserOnTrial = false
    planInfo = <SubscriptionModel>{};
    businessSetup = <BusinessSetupModel>{}
    isPlanExpired = false;
    planExpiredDateText = '';
    planExpiresInDays: number | null = null;
    isPlanExpiringSoon = false;
    showPlanBanner = false;
    planBannerReturnUrl: string | null = null;
    showPlanBannerBackButton = false;
    isOnBillingPage = false;
    /** Hard lockout — distinct from showPlanBanner (which only warns). True once the free trial's
     *  end date has fully passed (through 11:59:59 PM local time on that date, not just midnight)
     *  and there's still no billing card on file. Blocks the entire app behind an overlay — the
     *  only thing the overlay itself offers is the Add card form — regardless of how
     *  isPlanExpired/showPlanBanner are set. */
    trialLockedOut = false;
    lastVisitedRoute: string | null = null;
    hasRestoredRoute: boolean = false;
    showUpgradeBtn: boolean = true;
    private readonly pageBannerClass = 'dashboard-v2-banner-active';
    private readonly storeContentStatusOverridePrefix = 'dashboard-v2-store-content-status-override';
    private readonly storeContentStatusDoing = 'doing';
    private readonly defaultPendingBannerMessage =
        'Your store content file is still pending. Please upload it to start your online store setup.';
    private readonly defaultInProgressBannerMessage =
        'Your online store is being set up. Your store link will be available once setup is complete.';
    private readonly defaultCompletedBannerMessage =
        'Your store content request is completed successfully. Your online store is production ready.';
    showStoreContentBanner = false;
    isStoreContentBannerCompleted = false;
    storeContentBannerMessage = '';
    showStoreContentDashboardLink = false;
    isOnlineStoreSetupPage = false;

    constructor(public renderer: Renderer2,
        public app: AppComponent, public configService: ConfigService,
        private _userService: UserService,
        @Inject(DOCUMENT) private _document: HTMLDocument,
        private title: Title,
        public _abd: AppBaseDataService,
        private route: ActivatedRoute,
        public _subscriptionManagementService: SubscriptionPlanService,
        private _router: Router,
        public layoutService: LayoutService,
        private businessSetupService: BusinessSetupService,
        private businessSetupProgressService: BusinessSetupProgressService) { }

    @HostListener('window:resize', ['$event'])
    onWindowResize() {
        this._abd.getScreenWidth = window.innerWidth;
        this._abd.getScreenHeight = window.innerHeight;
        if (!this.isDesktop()) {
            this.hideTopMenu();
        }
    }

    @HostListener('window:storage', ['$event'])
    onWindowStorageChange(event: StorageEvent) {
        if (!event) {
            return;
        }

        if (event.key && !event.key.startsWith(this.storeContentStatusOverridePrefix)) {
            return;
        }

        this.refreshStoreContentBanner();
    }

    ngOnInit() {
         this.applyDeviceClass();
        const initialUrl = this._router.url;
        this.updateOnlineStoreSetupRouteState(initialUrl);
        this.updateViewport(initialUrl);
        this.restoreLastRoute(initialUrl);
        this.config = this.configService.config;
        this.subscription = this.configService.configUpdate$.subscribe(config => this.config = config);
        this.storeContentStateRefreshSubscription = this.businessSetupService.storeContentStateRefresh$.subscribe(() => {
            this.refreshStoreContentBanner();
        });
        
        // Subscribe to menu close events from navigation
        this._abd.closeMenu$.subscribe(() => {
            this.menuActiveMobile = false;
            this.layoutService.state.staticMenuMobileActive = false;
        });
        
      
        this.checkTour()
        this._router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: any) => {
            this.updateViewport(event.urlAfterRedirects);
            if (event instanceof NavigationStart) {
                // Show loading indicator
            }

            if (event instanceof NavigationEnd) {
                this.updateOnlineStoreSetupRouteState(event.urlAfterRedirects || event.url);
                // Re-check whether Stripe has since been connected (e.g. the merchant just came
                // back from the Connect Stripe step) so the lockout clears without a full reload.
                if (this.trialLockedOut) {
                    this.checkTrialLockout();
                }
                if (this._router.url == '/app/billing-and-plans') {
                    // if (this._router.url == '/app/subscription-management') {
                    this.showUpgradeBtn = false;
                }
                else {
                    this.showUpgradeBtn = true;
                }

                this.isOnBillingPage = this._router.url?.includes('/app/billing-and-plans');
                this.planBannerReturnUrl = sessionStorage.getItem('plan-banner-return-url');
                this.showPlanBannerBackButton = this.isOnBillingPage && !!this.planBannerReturnUrl;

                const persistedUrl = event.urlAfterRedirects || event.url;
                this.maybeStoreLastRoute(persistedUrl);
                this.refreshStoreContentBanner();
            }

            if (event instanceof NavigationError) {
                // Hide loading indicator

                // Present error to user
            }
        });

        this.businessSetup = this._globals.userInfo?.businessSetup?.[0];
        this.planInfo = this.businessSetup?.subscription;
        this.IsUserOnTrial = this.businessSetup?.isFreeTrial === true;

        const startDate = this.IsUserOnTrial
            ? new Date()
            : this.parseDateValue(this.businessSetup?.createdDate);
        const endDate = this.IsUserOnTrial
            ? this.parseDateValue(this.businessSetup?.freeTrialEndDate)
            : this.parseDateValue(this.planInfo?.nextChargeDate ?? this.planInfo?.endDate);

        if (startDate && endDate) {
            const diff = Math.abs(endDate.getTime() - startDate.getTime());
            this.dayLeftInRenewal = Math.ceil(diff / (1000 * 3600 * 24));
        } else {
            this.dayLeftInRenewal = 0;
        }

        this.checkPlanExpiredStatus();
        this.refreshStoreContentBanner();
        this.loadStoreContentBannerConfiguration();

        //++++++++++++++++++++++

        // const sourceUrl = (window.location.href).toLowerCase()


        // if (sourceUrl.includes('localhost:')) wll = WhiteLabelList[0] // to be deleted later
        // else {
        //     for (let i = 0; i < WhiteLabelList.length; i++) {
        //         if (sourceUrl.includes(WhiteLabelList[i].wlName.toLowerCase() + '.net')) {
        //             wll = WhiteLabelList[i]
        //             break
        //         }
        //     }
        // }

        // if (!wll) wll = WhiteLabelList[0] // to be deleted later
        // if (wll) {
        //     this._globals.whiteLabel = wll
        //     if (this._userService.isUserAutoLogin()) {
        //
        //         this._userService.setCurrentUserFromLocalStorage()
        //         this._userService.getUserByUserName(this._userService.currentUserObj.userName)
        //         this._userService.getUserRoles()
        //         this._document.getElementById('appFavicon')?.setAttribute('href', 'assets/images/' + wll.favIcon + '.ico')
        //         this.title.setTitle(wll.wlName)
        //         this._abd.loadInit()
        //         //this._router.navigate(['']);
        //     }
        //     else
        //         this._router.navigate(['pages/signin']);
        // } else {
        //     this._router.navigate(['/error']);
        // }
    }

    private parseDateValue(value: any): Date | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const parsedDate = new Date(value);
        return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    private updateViewport(url: string): void {
        const viewport = document.querySelector('meta[name=viewport]');
        if (!viewport) return;

        // Always allow responsive layout so mobile screens render correctly
        viewport.setAttribute('content', 'width=device-width, initial-scale=1');
        document.body.classList.remove('desktop-view');
    }

    private applyDeviceClass(): void {
        const ua = navigator.userAgent.toLowerCase();
        let deviceClass = 'is-desktop';

        if (/mobile|iphone|ipod|android|blackberry|iemobile|opera mini/.test(ua)) {
            deviceClass = 'is-mobile';
        } else if (/ipad|tablet|playbook/.test(ua)) {
            deviceClass = 'is-tablet';
        }

        document.body.classList.add(deviceClass);
    }

    // Legacy store-setup-offer / welcome-store-setup(-v2) nudge — hardcoded to redirect to
    // /signup-v5/store-setup-offer regardless of which signup version the user actually used.
    // Superseded by the welcome-setup-modal + business-setup checklist embedded in dashboard-v2;
    // no longer navigates away, just keeps the showSetup flag other flows still read in sync.
    checkTour() {
        const showSetup = localStorage.getItem('showSetup') === 'false';
        if (!showSetup && this._globals.userInfo.businessSetup[0]?.isTour === false) {
            localStorage.setItem('showSetup', 'true');
        } else {
            localStorage.setItem('showSetup', 'false');
        }
    }

    ngAfterViewInit() {
        // hides the overlay menu and top menu if outside is clicked
        this.documentClickListener = this.renderer.listen('body', 'click', (event) => {
            const target = event.target as HTMLElement;
            const isClickInsideMenu = target.closest('.layout-sidebar') || target.closest('.layout-menu-container');
            
            if (!this.isDesktop()) {
                // Close menu only if clicked outside (menu items close it via command)
                if (!this.menuClick && !isClickInsideMenu) {
                    this.menuActiveMobile = false;
                    this.layoutService.state.staticMenuMobileActive = false;
                }

                if (!this.topMenuButtonClick) {
                    this.hideTopMenu();
                }
            }
            else {
                if (!this.menuClick && this.isOverlay()) {
                    this.menuInactiveDesktop = true;
                }
                if (!this.menuClick && !isClickInsideMenu) {
                    this.overlayMenuActive = false;
                }
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            this.configClick = false;
            this.menuClick = false;
            this.topMenuButtonClick = false;
        });
    }
    ngDoCheck(): void {
        if (this._router.url.includes('app/online-store')) {
            this.isOnlineStore = true;
        } else {
            this.isOnlineStore = false;
        }
    }
    toggleMenu(event: Event) {
        this.menuClick = true;
        this._globals.moveMainMenuToggleSwitch = !this._globals.moveMainMenuToggleSwitch

        if (this.isDesktop()) {
            if (this.app.menuMode === 'overlay') {
                if (this.menuActiveMobile === true) {
                    this.overlayMenuActive = true;
                }

                this.overlayMenuActive = !this.overlayMenuActive;
                this.menuActiveMobile = false;
            }
            else if (this.app.menuMode === 'static') {
                this.staticMenuInactive = !this.staticMenuInactive;
            }
        }
        else {
            this.menuActiveMobile = !this.menuActiveMobile;
            this.layoutService.state.staticMenuMobileActive = this.menuActiveMobile;
            this.topMenuActive = false;
        }

        event.preventDefault();
    }

    toggleMenuDummy() {
        this.menuClick = true;
        this.menuActiveMobile = false;
        this.layoutService.state.staticMenuMobileActive = false;
        this.overlayMenuActive = false;
        this.staticMenuInactive = true;
    }

    toggleProfile(event: Event) {
        this.profileActive = !this.profileActive;
        event.preventDefault();
    }

    toggleTopMenu(event: Event) {
        this.topMenuButtonClick = true;
        this.menuActiveMobile = false;
        this.layoutService.state.staticMenuMobileActive = false;

        if (this.topMenuActive) {
            this.hideTopMenu();
        } else {
            this.topMenuActive = true;
        }

        event.preventDefault();
    }

    hideTopMenu() {
        this.topMenuLeaving = true;
        setTimeout(() => {
            this.topMenuActive = false;
            this.topMenuLeaving = false;
        }, 1);
    }

    onMenuClick() {
        this.menuClick = true;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    isStatic() {
        return this.app.menuMode === 'static';
    }

    isOverlay() {
        return this.app.menuMode === 'overlay';
    }

    isDesktop() {
        return window.innerWidth > 992;
    }

    isMobile() {
        return window.innerWidth < 1024;
    }

    onSearchClick() {
        this.topMenuButtonClick = true;
    }

    checkPlanExpiredStatus() {
        const business = this._globals.userInfo?.businessSetup?.[0];
        if (!business) {
            this.isPlanExpired = false;
            this.isPlanExpiringSoon = false;
            this.planExpiresInDays = null;
            this.showPlanBanner = false;
            return;
        }

        // Hide banner for Admin users
        if ((this._globals.userInfo?.type || '').toLowerCase() === 'admin') {
            this.isPlanExpired = false;
            this.isPlanExpiringSoon = false;
            this.planExpiresInDays = null;
            this.showPlanBanner = false;
            return;
        }

        const status = (business.accountStatusString || '').toString().toLowerCase();
        const expiredByStatus = status.includes('expired');

        // .NET's default/unset DateTime serializes as "0001-01-01T00:00:00" (DateTime.MinValue) —
        // e.g. a Free-plan account's subscription.endDate/nextChargeDate, which was never actually
        // set since Free never bills. Treated as "no date" rather than a real (and wildly overdue)
        // expiry date — without this, every such account shows a false "subscription has expired,
        // last active January 01, 0001" banner.
        const isUnsetDotNetDate = (value: any): boolean => typeof value === 'string' && value.startsWith('0001-01-01');

        const rawEndDate = business.isFreeTrial
            ? business.freeTrialEndDate
            : business.subscription?.endDate || business.subscription?.nextChargeDate;
        const endDate = isUnsetDotNetDate(rawEndDate) ? null : rawEndDate;
        const now = Date.now();
        // A free trial is valid through the END of its last day (11:59:59.999 PM local time),
        // not the raw stored timestamp — which is typically midnight of that date and would
        // otherwise mark the trial expired a full day early.
        const endTime = endDate
            ? (business.isFreeTrial ? this.endOfLocalDay(endDate) : new Date(endDate).getTime())
            : null;
        const expiredByDate = endTime ? endTime < now : false;

        if (endTime) {
            const diffMs = endTime - now;
            this.planExpiresInDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        } else {
            this.planExpiresInDays = null;
        }

        this.planExpiredDateText = endDate
            ? formatDate(new Date(endDate), 'MMMM dd, yyyy', 'en-US')
            : '';

        this.isPlanExpired = expiredByStatus || expiredByDate;
        this.isPlanExpiringSoon = !this.isPlanExpired && this.planExpiresInDays !== null && this.planExpiresInDays <= 3;
        this.showPlanBanner = this.isPlanExpired || this.isPlanExpiringSoon;

        if (business.isFreeTrial && expiredByDate) {
            this.checkTrialLockout();
        } else {
            this.trialLockedOut = false;
        }
    }

    /** Midnight-to-midnight local-time end-of-day timestamp for a stored date, so "expired" means
     *  past 11:59:59 PM on that calendar day in the merchant's own device time zone, not past the
     *  raw (often midnight) timestamp the backend stored. */
    private endOfLocalDay(date: string | Date): number {
        const d = new Date(date);
        d.setHours(23, 59, 59, 999);
        return d.getTime();
    }

    /** Once the trial has genuinely ended, whether the whole app gets locked behind the Add-card
     *  overlay hinges on real billing-card state (BusinessSetupProgressService.hasCardOnFile —
     *  BusinessSetup.Subscription.TransactionDetails.CardLast4), not just the trial date — a
     *  merchant who already added a card must keep working uninterrupted. This reads the already
     *  in-memory GlobalService.userInfo, so unlike the old Stripe-Connect check it needs no HTTP
     *  round trip and can be called freely (e.g. on every NavigationEnd while locked out). */
    private checkTrialLockout(): void {
        this.trialLockedOut = !this.businessSetupProgressService.hasCardOnFile;
    }

    /** The overlay's Add-card popup emits this once attachPaymentMethod() confirms the card is on
     *  file — patch the in-memory user record (so hasCardOnFile flips immediately) and drop the
     *  lockout right away rather than waiting on the next NavigationEnd to re-check. */
    onLockoutCardSaved(event: StripeCardSavedEvent): void {
        this.businessSetupProgressService.applyCardOnFile(event);
        this.trialLockedOut = false;
    }

    goToBillingAndPlans(fromBanner = false) {
        if (fromBanner && !this._router.url.includes('/app/billing-and-plans')) {
            sessionStorage.setItem('plan-banner-return-url', this._router.url);
            this.planBannerReturnUrl = this._router.url;
        }
        this._router.navigate(['app/billing-and-plans']);
    }

    goBackFromBilling() {
        const url = sessionStorage.getItem('plan-banner-return-url');
        if (url) {
            sessionStorage.removeItem('plan-banner-return-url');
            this.planBannerReturnUrl = null;
            this.showPlanBannerBackButton = false;
            this._router.navigateByUrl(url);
        }
    }

    private isPersistableRoute(url: string): boolean {
        if (!url) return false;
        // Only persist app routes (avoid auth/signup pages)
        return url.startsWith('/app/');
    }

    private restoreLastRoute(currentUrl: string) {
        if (this.hasRestoredRoute) return;
        const saved = sessionStorage.getItem('last-visited-route');
        this.hasRestoredRoute = true;
        if (saved && saved !== currentUrl && this.isPersistableRoute(saved)) {
            this._router.navigateByUrl(saved);
        }
    }

    private maybeStoreLastRoute(url: string) {
        if (!this.isPersistableRoute(url)) return;
        this.lastVisitedRoute = url;
        sessionStorage.setItem('last-visited-route', url);
    }

    ngOnDestroy() {
        this.removeStoreContentBannerBodyClass();
        if (this.documentClickListener) {
            this.documentClickListener();
        }


        if (this.subscription) {
            this.subscription.unsubscribe();
        }

        this.storeContentBannerConfigSubscription?.unsubscribe();
        this.storeContentStateRefreshSubscription?.unsubscribe();
    }

    private refreshStoreContentBanner(): void {
        const setup = this.getBusinessSetupStoreContentData();
        if (this.isOnlineStoreSetupRoute(this._router.url || '') || !this.shouldEnableStoreContentBanner(setup)) {
            this.showStoreContentBanner = false;
            this.isStoreContentBannerCompleted = false;
            this.storeContentBannerMessage = '';
            this.showStoreContentDashboardLink = false;
            this.removeStoreContentBannerBodyClass();
            return;
        }

        const showNotificationBar = this.extractStoreContentShowNotificationBar(setup);
        if (showNotificationBar === false) {
            this.showStoreContentBanner = false;
            this.isStoreContentBannerCompleted = false;
            this.storeContentBannerMessage = '';
            this.showStoreContentDashboardLink = false;
            this.removeStoreContentBannerBodyClass();
            return;
        }

        const hasSubmissionEvidence = this.hasStoreContentSubmissionEvidence(setup);

        let normalizedStatus =
            this.readStoreContentStatusOverride(setup) ||
            this.normalizeStoreContentStatus(
                setup?.storeContentStatus
                ?? setup?.StoreContentStatus
                ?? setup?.storecontentStatus
                ?? setup?.storeContentstatus
                ?? setup?.storecontentstatus
                ?? setup?.status
                ?? setup?.Status
            );

        if (!normalizedStatus) {
            normalizedStatus = 'inprogress';
        }

        if (normalizedStatus === 'inprogress' && !hasSubmissionEvidence) {
            normalizedStatus = 'pendingbyclient';
        }

        this.isStoreContentBannerCompleted = normalizedStatus === 'completed';
        // Completed status is never surfaced as a banner — once the store is production ready
        // there's nothing actionable left to tell the merchant, so only the pending/in-progress
        // states show.
        this.showStoreContentBanner =
            normalizedStatus === 'pendingbyclient' ||
            normalizedStatus === 'inprogress';
        this.showStoreContentDashboardLink =
            normalizedStatus === 'pendingbyclient' && !this.isDashboardRoute(this._router.url || '');

        if (normalizedStatus === 'completed') {
            this.storeContentBannerMessage = this.defaultCompletedBannerMessage;
        } else if (normalizedStatus === 'inprogress') {
            this.storeContentBannerMessage = this.defaultInProgressBannerMessage;
        } else {
            this.storeContentBannerMessage = this.defaultPendingBannerMessage;
        }

        if (this.showStoreContentBanner) {
            this._document.body.classList.add(this.pageBannerClass);
            return;
        }

        this.removeStoreContentBannerBodyClass();
    }

    private removeStoreContentBannerBodyClass(): void {
        this._document.body.classList.remove(this.pageBannerClass);
    }

    private isOnlineStoreSetupRoute(url: string): boolean {
        return String(url || '').split('?')[0].split('#')[0].endsWith('/app/online-store-setup');
    }

    private updateOnlineStoreSetupRouteState(url: string): void {
        this.isOnlineStoreSetupPage = this.isOnlineStoreSetupRoute(url);
        if (this.isOnlineStoreSetupPage) {
            this.removeStoreContentBannerBodyClass();
        }
    }

    private loadStoreContentBannerConfiguration(): void {
        this.storeContentBannerConfigSubscription?.unsubscribe();
        this.storeContentBannerConfigSubscription = this._userService.getWebStoreConfiguration().subscribe({
            next: (res: any) => {
                if (res?.success) {
                    this._globals.webStoreConfiguration = res.data;
                    this.refreshStoreContentBanner();
                }
            },
            error: () => {
                // Keep existing banner state if config refresh fails.
            }
        });
    }

    goToDashboardFromStoreContentBanner(): void {
        this._router.navigate([this._abd.getDashboardRoute()], {
            queryParams: {
                openSetup: 'store-content'
            }
        });
    }

    private getBusinessSetupStoreContentData(): any {
        const globalSetup = this._globals.userInfo?.businessSetup?.[0] || null;
        let sessionSetup: any = null;
        try {
            sessionSetup = JSON.parse(sessionStorage.getItem('business-Info') || 'null');
        } catch {
            sessionSetup = null;
        }

        const configurationSetup = this.getCurrentWebStoreConfigurationData();
        return {
            ...(sessionSetup || {}),
            ...(globalSetup || {}),
            ...(configurationSetup || {})
        };
    }

    private shouldEnableStoreContentBanner(setup: any): boolean {
        if (!setup) {
            return false;
        }

        const availSaveOffer = this.toBooleanFlag(setup?.availSaveOffer ?? setup?.AvailSaveOffer);
        return availSaveOffer || !!this.readStoreContentStatusOverride(setup);
    }

    private readStoreContentStatusOverride(setup?: any): string {
        try {
            const raw = localStorage.getItem(this.getStoreContentStatusOverrideKey(setup)) || '';
            return this.normalizeStoreContentStatus(raw);
        } catch {
            return '';
        }
    }

    private getStoreContentStatusOverrideKey(setup?: any): string {
        const resolvedSetup = setup || this.getBusinessSetupStoreContentData() || {};
        const businessId = String(resolvedSetup?.businessId ?? resolvedSetup?.id ?? 'default-business');
        const userId = String(
            this._globals.userInfo?.userID ??
            this._globals.userInfo?.userId ??
            resolvedSetup?.userID ??
            resolvedSetup?.userId ??
            'default-user'
        );
        return `${this.storeContentStatusOverridePrefix}-${userId}-${businessId}`;
    }

    private normalizeStoreContentStatus(value: any): string {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        const normalized = String(value).trim().toLowerCase();
        if (
            normalized === '1' ||
            normalized === 'pending by client' ||
            normalized === 'pendingbyclient' ||
            normalized === 'pending_by_client' ||
            normalized === 'pending-by-client'
        ) {
            return 'pendingbyclient';
        }

        if (
            normalized === '0' ||
            normalized === 'in progress' ||
            normalized === 'inprogress' ||
            normalized === this.storeContentStatusDoing
        ) {
            return 'inprogress';
        }

        if (normalized === '2' || normalized === 'completed') {
            return 'completed';
        }

        if (normalized === '3' || normalized === 'other') {
            return 'other';
        }

        return normalized;
    }

    private extractStoreContentShowNotificationBar(data: any): boolean | null {
        const rawValue =
            data?.storeContentShowNotificationBar ??
            data?.StoreContentShowNotificationBar ??
            data?.storecontentshownotificationbar;

        if (rawValue === null || rawValue === undefined || rawValue === '') {
            return null;
        }

        if (typeof rawValue === 'boolean') {
            return rawValue;
        }

        const normalized = String(rawValue).trim().toLowerCase();
        if (normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'off') {
            return false;
        }

        if (normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on') {
            return true;
        }

        return null;
    }

    private hasStoreContentSubmissionEvidence(setup: any): boolean {
        const globalSetup = this._globals.userInfo?.businessSetup?.[0] || {};
        let sessionSetup: any = {};
        try {
            sessionSetup = JSON.parse(sessionStorage.getItem('business-Info') || '{}') || {};
        } catch {
            sessionSetup = {};
        }

        const resolvedSetup = {
            ...sessionSetup,
            ...globalSetup
        };
        const storeContentFileUrl = String(
            resolvedSetup?.storeContentFileUrl ??
            resolvedSetup?.StoreContentFileUrl ??
            resolvedSetup?.storecontentFileUrl ??
            ''
        ).trim();

        return !!storeContentFileUrl;
    }

    private getCurrentWebStoreConfigurationData(): any {
        const config = this._globals.webStoreConfiguration;
        if (Array.isArray(config)) {
            return config.find((item: any) => item?.isDefault === true) || config[0] || null;
        }

        if (typeof config === 'object' && config !== null) {
            return config;
        }

        return null;
    }

    private isDashboardRoute(url: string): boolean {
        return String(url || '').includes('/app/dashboard-v2');
    }

    private toBooleanFlag(value: any): boolean {
        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase();
            return normalized === 'true' || normalized === '1';
        }

        return value === true || value === 1;
    }

    navigateToSubscription() {
        sessionStorage.setItem('is-Redirect', 'Yes')
        setTimeout(() => {

            this._router.navigateByUrl('signup/check-out')
        }, 100);
        // this._router.navigateByUrl('app/billing-and-plans')
        // this._router.navigateByUrl('app/subscription-management')
    }
}
